<script setup lang="ts">
onMounted(() => {
  const route = useRoute();
  const appMounted = useState("appMounted");

  const { sendScreenView } = useAnalytics();
  if (appMounted.value) sendAnalytics();
  watch(appMounted, () => sendAnalytics);

  function sendAnalytics() {
    sendScreenView({ type: "PageView", target: `Solutions.${String(route.name)}` }, true);
  }
});
</script>

<template>
  <main class="container solutions">
    <slot />
  </main>
</template>

<style lang="scss">
main.solutions {
  margin-top: 89px;

  .feature-content {
    color: white;
    margin: auto;
    max-width: 1366px;
  }
}
</style>
